import { memo } from 'react';

import { OButton, OModal } from '@src/shared';

import './ExitRoomModal.scss';
import useExitRoomModal from './useExitRoomModal';

type TRoomType = 'webinar' | 'meet';

interface IProps {
  roomType?: TRoomType;
}

const ExitRoomModal = ({ roomType = 'meet' }: IProps) => {
  const { isOpenModal, closeModal, title, buttons } = useExitRoomModal(roomType);

  return (
    <OModal
      isOpen={isOpenModal}
      onClose={closeModal}
      hasBackdrop
      classes={{ container: 'exit-room-modal', body: 'exit-room-body' }}
    >
      <h2 className="screen-exit-title">{title}</h2>
      <div className="button-group">
        {buttons.map(({ text, onClick }, i) => (
          <OButton key={i} text={text} onClick={onClick} variant="secondary" size="default" />
        ))}
      </div>
    </OModal>
  );
};

export default memo(ExitRoomModal);
